import { motion } from 'framer-motion';
import { LuMapPin, LuClock, LuDollarSign, LuArrowRight } from 'react-icons/lu';

const positions = [
  {
    title: 'Senior Full Stack Engineer',
    department: 'Engineering',
    location: 'Remote',
    type: 'Contract',
    description: 'We are looking for an experienced full-stack engineer to build scalable web applications with React, Node.js, and modern cloud technologies.'
  },
  {
    title: 'Mobile App Developer',
    department: 'Engineering',
    location: 'Remote',
    type: 'Contract',
    description: 'Join our mobile team to create exceptional iOS and Android applications using React Native and Flutter.'
  },
  {
    title: 'DevOps Engineer',
    department: 'Infrastructure',
    location: 'Remote',
    type: 'Contract',
    description: 'Build and maintain our cloud infrastructure, CI/CD pipelines, and help teams deploy with confidence.'
  },
  {
    title: 'UI/UX Designer',
    department: 'Design',
    location: 'Remote',
    type: 'Contract',
    description: 'Create beautiful, intuitive interfaces and design systems that delight users and scale across products.'
  },
  {
    title: 'AI/ML Engineer',
    department: 'Engineering',
    location: 'Remote',
    type: 'Contract',
    description: 'Develop cutting-edge AI solutions and integrate machine learning models into production systems.'
  },
  {
    title: 'Technical Writer',
    department: 'Content',
    location: 'Remote',
    type: 'Contract',
    description: 'Create comprehensive technical documentation, tutorials, and guides for our products and APIs.'
  }
];

const benefits = [
  'Flexible remote work',
  'Unlimited PTO',
  'Learning & development budget',
  'Latest tech equipment',
  'Team retreats',
  '401(k) matching'
];

export default function Careers() {
  return (
    <div className="bg-slate-950 pt-32" data-testid="careers-page">
      <section className="py-24 md:py-32" data-testid="careers-hero">
        <div className="container mx-auto px-4 md:px-8">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto text-center space-y-6"
          >
            <span className="text-sm font-medium text-blue-400 uppercase tracking-widest">Join Our Team</span>
            <h1 className="font-heading text-5xl md:text-6xl font-bold tracking-tight text-white leading-tight">
              Build the Future with <span className="text-gradient-blue">TechMeetsU</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-300 leading-relaxed">
              Join a team of passionate engineers building scalable solutions with clean architecture and long-term vision.
            </p>
          </motion.div>
        </div>
      </section>




      <section className="py-24 bg-slate-900/30" data-testid="careers-cta">
        <div className="container mx-auto px-4 md:px-8">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl mx-auto text-center space-y-6"
          >
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-white">
              Don't See Your Role?
            </h2>
            <p className="text-lg text-slate-300">
              We're always looking for talented individuals. Send us your resume and let's talk.
            </p>
            <a
              href="mailto:admin@techmeetsu.com"
              className="inline-flex items-center space-x-2 bg-gradient-to-r from-orange-600 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white px-10 py-5 rounded-full text-lg font-medium transition-all shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50"
              data-testid="general-application-button"
            >
              <span>Send Your Resume</span>
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
}